import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { getSessionJSON } from './utils/SessionUtils';
import { ensureContextLoaded } from './actions/contextActions';

export default function ProtectedRoute({ children }) {
  const loginData = getSessionJSON("login-data");
  const [contextReady, setContextReady] = useState(() => {
    const contexts = getSessionJSON("CONTEXTS");
    return Boolean(contexts?.length);
  });

  useEffect(() => {
    if (!loginData) {
      return;
    }
    const contexts = getSessionJSON("CONTEXTS");
    if (contexts?.length) {
      setContextReady(true);
      return;
    }
    ensureContextLoaded()
      .catch((err) => console.error("Failed to load context:", err))
      .finally(() => setContextReady(true));
  }, [loginData]);

  if (!loginData) {
    return <Navigate to="/" replace />;
  }
  if (!contextReady) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  return children;
}